import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modals: {
    edit: {
      open: false,
      id: null,
      domain: null,
    },
    delete: {
      open: false,
      id: null,
      domain: null,
    },
  },
};

const nationalUniversityControlSlice = createSlice({
  name: "nationalUniversityControl",
  initialState: initialState,
  reducers: {
    openModal: (state, action) => {
      const { id, domain, modalType } = action.payload;
      state.modals[modalType] = { open: true, id, domain };
    },
    closeModal: (state, action) => {
      const { modalType } = action.payload;
      state.modals[modalType] = { open: false, id: null, domain: null };
    },
  },
});

export const { openModal, closeModal } = nationalUniversityControlSlice.actions;
export default nationalUniversityControlSlice.reducer;
